import { render, staticRenderFns } from "./updateDetail.vue?vue&type=template&id=347fc4f6&scoped=true&"
import script from "./updateDetail.vue?vue&type=script&lang=js&"
export * from "./updateDetail.vue?vue&type=script&lang=js&"
import style0 from "./updateDetail.vue?vue&type=style&index=0&id=347fc4f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347fc4f6",
  null
  
)

export default component.exports